import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import WavingHandOutlinedIcon from '@mui/icons-material/WavingHandOutlined';
import { Typography } from '@mui/material';

import BackgroundImage from '../../components/general/BackgroundImage';
import GoBackText from '../../components/general/GoBackText';
import { StyledTwoScreensWrapper } from '../../components/modules/AuthPage/Styles';
import { MessageWithTipMui } from '../../components/modules/AuthPage/setup/MessageWithTipMui';
import { getOperatorApexUrl } from '../../utils/env/urlStrings';
import { DescriptionContainer, styleText } from './Styles';
import loggedOutImg from '@/operator/public/assets/images/background/logout.svg';

const Description = () => {
    const { t } = useTranslation();
    const operatorUrl = useMemo(getOperatorApexUrl, []);

    return (
        <DescriptionContainer>
            <Typography variant="body1" sx={{ ...styleText }}>
                {t('LogOutPage.Content.Description')}
            </Typography>
            <Typography variant="body1" sx={{ ...styleText }} align="left">
                {t('LogOutPage.Content.SecondDescription')}
            </Typography>
            <GoBackText
                value={t('LogOutPage.Content.BackButton')}
                externalLink={operatorUrl}
            />
        </DescriptionContainer>
    );
};

const LoggedOut = (): JSX.Element => {
    const { t } = useTranslation();

    return (
        <StyledTwoScreensWrapper>
            <MessageWithTipMui
                Icon={WavingHandOutlinedIcon}
                headlineVariant="h2"
                headline={t('LogOutPage.Content.Header')}
                description={<Description />}
            />

            <BackgroundImage src={loggedOutImg} />
        </StyledTwoScreensWrapper>
    );
};

export default LoggedOut;
